import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactApexChart from 'react-apexcharts';

const Chart = ({datos}) => {
    const { t } = useTranslation('common');
    let data = []
    datos = datos.map(property => property.workcenters?.length === 0 ? property : property.workcenters)?.flat()
    // datos = datos.map(property => property)?.flat()
    data.push(datos.filter(item => item.pendiente).length, datos.filter(item => item.visitada).length, datos.filter(item => item.renovada).length, datos.filter(item => item.renovadaVisitada).length)
    const series = data
    
    const options = {
        chart: {
          width: '100%',
          type: 'pie',
        },
        labels: [t('charts.pending'), t('charts.visit'), t('charts.renewed'), t('charts.renewedVisited')],
        theme: {
          monochrome: {
            enabled: true,
            color: '#92004D',
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -5
            }
          }
        },
        title: {
          text: t('charts.caeService')
        },
        dataLabels: window.innerWidth >= 992 ? {
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex]
            return [name, val.toFixed(1) + '%']
          }
        }:{},
        legend: {
          show: false
        }
    }
    return ( 
        <div id="chart">
            <ReactApexChart options={options} series={series} type="pie" />
        </div>
     );
}
 
export default Chart;